import React from "react";

import { useHistory } from "react-router-dom";

import PlusIcon from "../../icons/plus-icon";
import BackIcon from "../../icons/back-icon";
import PenIcon from "../../icons/pen-icon";
import BudgetIcon from "../../icons/budget-icon";
import RefreshIcon from "../../icons/refresh-icon";
import PrintIcon from "../../icons/print-icon";
import ExcelIcon from "../../icons/excel-icon";
import DeleteIcon from "../../icons/delete-icon";
import CloseIcon from "../../icons/close-icon";

const MainButton = ({ title, type, handleClick }) => {
  const history = useHistory();

  const renderIcon = () => {
    switch (type) {
      case "add":
        return <PlusIcon />;
      case "back":
        return <BackIcon />;
      case "pen":
        return <PenIcon />;
      case "budget":
        return <BudgetIcon />;
      case "refresh":
        return <RefreshIcon />;
      case "print":
        return <PrintIcon />;
      case "excel":
        return <ExcelIcon />;
      case "delete":
        return <DeleteIcon />;
      case "close":
        return <CloseIcon />;
    }
  };

  const handleMethod = () => {
    if (type === "back") {
      history.goBack();
    } else {
      if (handleClick) handleClick();
    }
  };

  return (
    <button
      className={`circle ${type}`}
      title={title}
      style={type === "delete" ? {fill: "red"} : {}}
      onClick={() => handleMethod()}
    >
      {renderIcon()}
    </button>
  );
};

export default MainButton;
